import {
  NaturalWrittenMultiplyOneDigitTask,
  NaturalWrittenMultiplyTwoByTwoTask,
  NaturalWrittenMultiplyFourByTwoTask,
  NaturalWrittenMultiplyThreeByThreeTask,
  NaturalWrittenMultiplyOneSideZerosTask,
  NaturalWrittenMultiplyWithZerosTask,
} from "./podtemat3_mnozenie_pisemne_types/NaturalWrittenMultiplicationTasks";

export const registry = {
  NaturalWrittenMultiplyOneDigitTask,
  NaturalWrittenMultiplyTwoByTwoTask,
  NaturalWrittenMultiplyFourByTwoTask,
  NaturalWrittenMultiplyThreeByThreeTask,
  NaturalWrittenMultiplyOneSideZerosTask,
  NaturalWrittenMultiplyWithZerosTask,
};

export function generateTasks() {
  return [
    NaturalWrittenMultiplyOneDigitTask.generateTask(),
    NaturalWrittenMultiplyTwoByTwoTask.generateTask(),
    NaturalWrittenMultiplyFourByTwoTask.generateTask(),
    NaturalWrittenMultiplyThreeByThreeTask.generateTask(),
    NaturalWrittenMultiplyOneSideZerosTask.generateTask(),
    NaturalWrittenMultiplyWithZerosTask.generateTask(),
  ];
}

export function renderTask(task) {
  return registry[task.type]?.renderTask(task) || null;
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return registry[task.type]?.renderInput(task, userAnswer, onChange, disabled) || null;
}

export function checkAnswer(task, userAnswer) {
  return registry[task.type]?.checkAnswer(task, userAnswer) || false;
}

export function renderAnswer(task) {
  return registry[task.type]?.renderAnswer(task) || null;
}

export function renderExplanation(task) {
  return registry[task.type]?.renderExplanation(task) || null;
}

export function renderUserAnswer(task, userAnswer) {
  return registry[task.type]?.renderUserAnswer(userAnswer) || null;
}
